export default __webpack_public_path__ + "static/media/main_menu2.c5228f3f.png";